import Flickity from 'flickity';
import 'flickity-fade';
import { THIN_ARROW_PATH } from '../../../app/Constants/Flickity';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll<HTMLElement>('.js-slider');
  const sliderNavBtns = [].slice.call(document.querySelectorAll('.js-icon-grid-btn'));

  sliders.forEach((elem) => {
    // cSpell:disable
    let draggable = elem.dataset.draggable;
    let wrap = elem.dataset.wrap;
    let cellAlign = elem.dataset.align;
    let nextPrev = elem.dataset.nextprev;
    let autoPlay = elem.dataset.autoplay;
    let watchCSS = elem.dataset.watchcss;
    let adaptiveHeight = elem.dataset.adaptiveheight;
    let fade = elem.dataset.fade;
    let freeScroll = elem.dataset.freescroll;
    let pageDots = elem.dataset.pagedots;
    let arrowShape = elem.dataset.arrowshape;
    let group = elem.dataset.group;
    // cSpell:enable
    const slides = elem.querySelectorAll('.js-slide');

    const flickityOptions: any = {
      cellSelector: '.js-slide',
      lazyLoad: 2,
      imagesLoaded: true,
      selectedAttraction: 0.012,
      // Options passed in
      draggable: draggable === 'false' ? false : '>1',
      wrapAround: wrap ? true : false,
      prevNextButtons: nextPrev ? true : false,
      autoPlay: autoPlay ? parseInt(autoPlay) : false,
      watchCSS: watchCSS ? true : false,
      adaptiveHeight: adaptiveHeight ? true : false,
      fade: fade ? true : false,
      freeScroll: freeScroll ? true : false,
      pageDots: pageDots === 'false' ? false : true,
      contain: true,
      on: {
        ready() {
          updateTabIndex(elem, slides);
        },
        change: function(index) {
          updateTabIndex(elem, slides);
          // for elements that have an nav bar, update the selected item on slide change
          if (elem.dataset.nav) {
            updateNav(index, elem);
          }
        },
      },
    };

    if (group) {
      flickityOptions.groupCells = group;
    }
    if (cellAlign) {
      flickityOptions.cellAlign = cellAlign;
    }
    if (arrowShape) {
      flickityOptions.arrowShape = arrowShape;
    }

    let slider = new Flickity(elem, flickityOptions);
    if (elem.hasAttribute('data-atelier-slider')) bindConciergeRecommendations(elem, slider, window.matchMedia('(max-width: 767px)'));

    // Flickity creates its pagination labels dynamically, outside authored copy.
    localizeNativeWatchPagination(elem);
    ['activate', 'cellChange', 'resize'].forEach((event) => {
      slider.on(event, () => localizeNativeWatchPagination(elem));
    });

    let prev = elem.parentElement?.querySelector('.js-prev') || elem.querySelector('.js-prev');
    let next = elem.parentElement?.querySelector('.js-next') || elem.querySelector('.js-next');
    
    prev?.addEventListener('click', () => {
      slider.previous();
    });

    next?.addEventListener('click', () => {
      slider.next();
    });

    let products = elem.querySelector('.hero-slider__products');

    products?.addEventListener('touchstart', () => {
      slider.options.draggable = false;
      slider.updateDraggable();
    });

    products?.addEventListener('touchend', () => {
      slider.options.draggable = true;
      slider.updateDraggable();
    });

    positionSliderBtns();
  });

  // update the current slide when a nav button is used to select the slide
  sliderNavBtns.forEach(function(btn) {
    btn.addEventListener('click', changeSlide);
  });

  window.onresize = positionSliderBtns;

  // Hero product sliders
  const heroProductSliders = document.querySelectorAll('.js-hero-product-slider');
  heroProductSliders.forEach((slider) => {
    new Flickity(slider, {
      draggable: true,
      cellSelector: '.js-hero-product-slide',
      wrapAround: true,
      lazyLoad: 2,
      imagesLoaded: true,
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: true,
      arrowShape: THIN_ARROW_PATH,
      freeScroll: false,
      autoPlay: false,
      // Using watchCSS to disable flickity when not enough slides to scroll on desktop
      // (with [data-enable-on-desktop] attr)
      watchCSS: true,
    });
  });
});


// Restrict this copy correction to the reviewed French native watch landings.
function localizeNativeWatchPagination(slider: HTMLElement) {
  const french = document.documentElement.lang.toLowerCase().split('-')[0] === 'fr';
  const active = document.querySelector('meta[name="raffi-native-preview"][content="20261008"], meta[name="raffi-native-release"][content="20261008"]');
  const path = window.location.pathname.replace(/^\/fr(?=\/|$)/i, '').replace(/\/$/, '');
  if (!french || !active || !/^\/(?:tudor|omega|zenith|breitling|grand-seiko|longines|oris|rado|mido|montblanc-timepieces|gucci-timepieces|frederique-constant|hamilton|movado|bulova|accutron|citizen|seiko|tissot)$/.test(path)) return;
  slider.querySelectorAll<HTMLElement>('.flickity-page-dots .flickity-page-dot, .flickity-page-dots [aria-label]').forEach((dot) => {
    // Flickity v3 uses button text, without an aria-label, for page dots.
    const text = (dot.textContent || '').trim();
    const match = /^View slide ([1-9]\d*)$/.exec(dot.getAttribute('aria-label') || text);
    if (!match) return;
    const label = `Voir la diapositive ${match[1]}`;
    dot.setAttribute('aria-label', label);
    if (!dot.childElementCount && /^View slide [1-9]\d*$/.test(text)) dot.textContent = label;
  });
  slider.querySelectorAll<HTMLElement>('.flickity-prev-next-button[aria-label]').forEach((button) => {
    const label = button.getAttribute('aria-label');
    if (label === 'Previous') button.setAttribute('aria-label', 'Précédent');
    if (label === 'Next') button.setAttribute('aria-label', 'Suivant');
  });
}

function changeSlide() {
  const sliderId = this.getAttribute('data-slide');
  const index = this.getAttribute('data-index');
  const slider = document.querySelector(`.js-slider[data-slide="${sliderId}"]`);
  const flickity = Flickity.data(slider);
  flickity.select(index, false, false);

  const allNavBtns = [].slice.call(document.querySelectorAll(`.js-icon-grid-btn[data-slide="${sliderId}"]`));
  allNavBtns.forEach(function(btn) {
    btn.classList.remove('selected');
  });

  this.classList.add('selected');
}

function updateNav(index, slider) {
  const sliderId = slider.getAttribute('data-slide');
  const allNavBtns = [].slice.call(document.querySelectorAll(`.js-icon-grid-btn[data-slide="${sliderId}"]`));
  allNavBtns.forEach(function(btn) {
    let btnIndex = btn.dataset.index;
    if (btnIndex === index) {
      btn.classList.add('selected');
    } else {
      btn.classList.remove('selected');
    }
  });
}

// set no tabindex on non-selected slides, and update tabindex to be clickable on selected slides
function updateTabIndex(slider, slides) {
  slides.forEach(function(slide) {
    const links = slide.tagName === 'A' || slide.tagName === 'BUTTON'
      ? [slide]
      : slide.querySelectorAll('a, button, iframe');
    if (links) {
      links.forEach(function(link) {
        link.setAttribute('tabindex', '-1');
      });
    }
  });

  const selectedSlides = slider.querySelectorAll('.is-selected');

  selectedSlides.forEach(function(slide) {
    const links = slide.tagName === 'A' || slide.tagName === 'BUTTON'
      ? [slide]
      : slide.querySelectorAll('a, button, iframe:not(.js-hidden)');
    if (links) {
      links.forEach(function(link) {
        link.setAttribute('tabindex', '0');
      });
    }
  });
}

// some of the sliders position the buttons centered to the image, not the entire slide

const positionSliderBtns = () => {
  const sliders = document.querySelectorAll('.js-slider[data-centre-btns]');
  sliders.forEach((elem) => {
    const sliderImage = elem.querySelector<HTMLElement>('.js-slide img');
    const btns = elem.querySelectorAll<HTMLElement>('.js-prev, .js-next, .flickity-prev-next-button');
    btns.forEach((btn) => {
      if (sliderImage) {
        btn.style.top = `${sliderImage?.offsetHeight / 2}px`;
      }
    });
  });

  const bottomSliders = document.querySelectorAll('.js-slider[data-bottom-btns]');
  bottomSliders.forEach((elem) => {
    const sliderImage = elem.querySelector<HTMLElement>('.js-slide img');
    const btns = elem.querySelectorAll<HTMLElement>('.js-prev, .js-next, .flickity-prev-next-button');
    btns.forEach((btn) => {
      if (sliderImage) {
        btn.style.top = `${sliderImage?.offsetHeight}px`;
      }
    });
  });
};

// When slider images load we need to fire a resize to adjust slider
let sliderImages = document.querySelectorAll('.js-slide img');
Array.from(sliderImages).forEach((img) => {
  img.addEventListener('load', () => {
    const slider = img.closest('.js-slider');
    const flickity = Flickity.data(slider);
    flickity?.resize();
    positionSliderBtns();
  });
});

// Slide height fix
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};
Flickity.create._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};
let resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

/* fix iOS touchmove issue */
;
// (function() {
//   let touchingCarousel = false;
//   let startXCoordinate;

//   document.body.addEventListener('touchstart', (e) => {
//     const target = e.target as HTMLButtonElement;
//     if (target?.closest('.flickity-slider')) {
//       touchingCarousel = true;
//     } else {
//       touchingCarousel = false;
//       return;
//     }
//     startXCoordinate = e.touches[0].pageX;
//   });

//   document.body.addEventListener('touchmove', (e) => {
//     if (
//       !touchingCarousel ||
//       !e.cancelable ||
//       Math.abs(e.touches[0].pageX - startXCoordinate) < 8
//     ) {
//       return;
//     }
//     e.preventDefault();
//     e.stopPropagation();
//   }, {
//     passive: false,
//   });
// }());

// /* prevent resize in flickity if still animating */
// const resize = Flickity.prototype.resize;
// Flickity.prototype.resize = function() {
//   if (!this.isAnimating) {
//     resize.call(this);
//   }
// };

/** Three compact mobile rows at a time; desktop retains its original Flickity carousel. */
function bindConciergeRecommendations(elem: HTMLElement, slider: any, media: MediaQueryList) {
  const section = elem.closest('[data-atelier-recommendations]');
  if (!section) return;
  const rows = Array.from(elem.querySelectorAll<HTMLElement>('[data-atelier-card]'));
  const count = section.querySelector<HTMLElement>('[data-atelier-count]');
  const previous = section.querySelector<HTMLButtonElement>('[data-atelier-navigation] .js-prev');
  const next = section.querySelector<HTMLButtonElement>('[data-atelier-navigation] .js-next');
  const pageSize = 3;
  let page = 0;
  const showPage = () => {
    const start = page * pageSize;
    rows.forEach((row, index) => {
      row.hidden = index < start || index >= start + pageSize;
      row.toggleAttribute('inert', row.hidden);
      row.classList.toggle('concierge-list__first', index === start);
      row.classList.toggle('concierge-list__last', index === Math.min(start + pageSize, rows.length) - 1);
      if (!row.hidden) {
        const lazySizes = (window as Window & { lazySizes?: { loader: { unveil(element: HTMLElement): void } } }).lazySizes;
        row.querySelectorAll<HTMLElement>('img.lazyload').forEach(image => lazySizes?.loader.unveil(image));
      }
      row.querySelectorAll<HTMLElement>('a, button, iframe').forEach((link) => {
        link.setAttribute('tabindex', row.hidden || link.getAttribute('aria-hidden') === 'true' ? '-1' : '0');
      });
    });
    if (count) count.textContent = `${start + 1}–${Math.min(start + pageSize, rows.length)} ${count.dataset.countWord} ${rows.length}`;
    if (previous) previous.disabled = page === 0;
    if (next) next.disabled = start + pageSize >= rows.length;
  };
  const changePage = (event: Event, direction: number) => {
    if (!media.matches) return;
    // The generic carousel listeners below must not also run for mobile list pages.
    event.stopImmediatePropagation();
    page = Math.max(0, Math.min(Math.ceil(rows.length / pageSize) - 1, page + direction));
    showPage();
    elem.scrollIntoView({ block: 'start', behavior: 'auto' });
    rows[page * pageSize]?.querySelector<HTMLElement>('.atelier-swipe__view')?.focus({ preventScroll: true });
  };
  previous?.addEventListener('click', event => changePage(event, -1));
  next?.addEventListener('click', event => changePage(event, 1));
  const resize = () => {
    const selected = slider.selectedElement;
    if (media.matches) {
      // Scoped CSS turns watchCSS off; deactivation returns each row to normal flow.
      slider.watchCSS();
      page = Math.max(0, Math.floor(rows.indexOf(selected) / pageSize));
      showPage();
    } else {
      rows.forEach(row => {
        row.hidden = false;
        row.removeAttribute('inert');
        row.classList.remove('concierge-list__first', 'concierge-list__last');
      });
      slider.watchCSS();
      slider.resize();
      slider.selectCell(rows[page * pageSize], false, true);
      updateTabIndex(elem, rows);
    }
  };
  if (media.addEventListener) media.addEventListener('change', resize);
  else media.addListener(resize);
  if (media.matches) showPage();
}
